







































































































import { Component, Vue } from "vue-property-decorator";
import HeatmapTable, {
  HeatmapTableColumn,
  HeatmapTableRow,
} from "@/components/HeatmapTable.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import NumberFormatter from "@/services/NumberFormatter";

@Component({
  components: {
    HeatmapTable,
    VSwitchButton,
  },
})
export default class Tables extends Vue {
  columns: HeatmapTableColumn[] = [];
  rows: HeatmapTableRow[] = [];

  randomizeTableData() {
    this.rows = [];
    this.columns = [
      {
        name: "title",
        label: "Title",
        notSortable: true,
        heading: true,
        tooltip: "Title",
      },
    ];

    const colCount = NumberFormatter.random(4, 8);

    for (let i = 0; i < colCount; i++) {
      this.columns.push({
        name: `value${i + 1}`,
        label: `Value ${i + 1}`,
      });
    }

    const rowCount = NumberFormatter.random(3, 10);

    for (let i = 0; i < rowCount; i++) {
      const row: HeatmapTableRow = {};

      this.columns.forEach((column) => {
        if (column.heading) {
          row[column.name] = `Row ${i + 1}`;
        } else {
          row[column.name] = Math.random() * 10000;
        }
      });

      this.rows.push(row);
    }
  }

  heatmap = false;

  created() {
    this.randomizeTableData();
  }
}
